export const dataHooks = {
  facesRatingItem: 'faces-rating-item',
};
